function env(key: string): string {
  return (import.meta.env[`VITE_${key}`] as string) ?? '';
}

export const ENV = {
  NODE_ENV: import.meta.env.MODE,
  BASE_URL: env('BASE_URL'),
  API_URL: env('API_URL'),
  SOCKET_URL: env('SOCKET_URL'),
  AUTH0_ID: env('AUTH0_ID'),
  AUTH0_DOMAIN: env('AUTH0_DOMAIN'),
  AUTH0_AUDIENCE: env('AUTH0_AUDIENCE'),
  AUTH0_BASE: env('AUTH0_BASE'),
  GOOGLE_API_KEY: env('GOOGLE_API_KEY'),
  GTM_ID: env('GTM_ID'),
  DEBUG: env('DEBUG'),
  CONFIG_ENV: env('CONFIG_ENV'),
  SENTRY_DSN: env('SENTRY_DSN'),
  CLOUDINARY_NAME: env('CLOUDINARY_NAME'),
  CLOUDINARY_API_KEY: env('CLOUDINARY_API_KEY'),
  ALGOLIA_APP_ID: env('ALGOLIA_APP_ID'),
  ALGOLIA_API_SKILLS_KEY: env('ALGOLIA_API_SKILLS_KEY'),
  PAGEVIEWS_FUNCTION: env('PAGEVIEWS_FUNCTION'),
  CLOUDINARY_FUNCTION: env('CLOUDINARY_FUNCTION'),
  S3_FUNCTION: env('S3_FUNCTION'),
  RUDDERSTACK_DATA_PLANE: env('RUDDERSTACK_DATA_PLANE'),
  RUDDERSTACK_WRITE_KEY: env('RUDDERSTACK_WRITE_KEY'),
  JOB_AUTOCOMPLETE_URL: env('JOB_AUTOCOMPLETE_URL'),
} as const;
